import { getAccommodationPath } from 'src/lib/urls/accommodation'

export type ErrorType = 'no-date' | 'unavailable'

export function getAccommodationErrorType(
  hasDate: boolean,
  isLoading: boolean,
  hasAvailabilities: boolean
): ErrorType | undefined {
  if (!hasDate) return 'no-date'
  if (!isLoading && hasDate && !hasAvailabilities) return 'unavailable'
  return undefined
}

export function getAccommodationRoomsUrl(id: number, slug: string) {
  return getAccommodationPath(id, slug, 'zimmer')
}
